module.exports = __webpack_public_path__ + "static/media/Backing@3x.d0f57966.png";